const facultyProfiles = [
  {
    id: "zoo001",
    name: "Dr. M. Nagabhushan Reddy",
    role: "Assistant Professor",
    department: "Zoology",
    university: "Rayalaseema University, Kurnool",

    photo: "/zoology/Drnagabushion.JPG",
    email: "mnabhushr@yahoo.com",
    phone: "8500981295",

    dateOfBirth: "05-06-1976",
    dateOfJoining: "27-07-2007",

    qualification: "B.Sc., M.Sc., M.Phil., Ph.D.",

    about:
      "Dr. M. Nagabhushan Reddy is a senior academician with over 18 years of teaching and research experience in Zoology. His expertise lies in Environmental Biology, Aquatic Ecology, and Biodiversity studies, focusing on environmental stress factors and ecosystem health. He has published extensively in national and international journals and actively contributes to academic and research communities.",

    education: [
      "B.Sc. – Sri Krishnadevaraya University (1996)",
      "M.Sc. – Sri Krishnadevaraya University (1998)",
      "M.Phil. & Ph.D. – Sri Krishnadevaraya University (2006)"
    ],

    specialization: [
      "Environmental Biology",
      "Aquatic Ecology",
      "Biodiversity & Ecology"
    ],

    experience: {
      teaching: "18 Years",
      research: "18 Years"
    },

    publications: {
      journalsInternational: 15,
      journalsNational: 10,
      conferences: 0,
      booksChapters: 0,
      total: 25
    },

    publicationsList: [
      {
        year: 2024,
        title:
          "Vulnerability of human blood groups to various diseases concerning age and sex",
        authors: "Nagabhushan Reddy M., et al.",
        journal: "Indian Journal of Natural Sciences",
        type: "International",
        doi: "10.31032/IJBPAS/2024/13.12.8506",
        link: "https://doi.org/10.31032/IJBPAS/2024/13.12.8506"
      }
    ],

    awards: [
      "CSIR–UGC JRF/NET – Qualified",
      "APSET – Qualified",
      "APPSC Screening Test – Qualified",
      "University First Rank – M.Sc. Zoology"
    ],

    memberships: [
      "Fellow – Hind Agri-Horticultural Society (FHAS)",
      "Life Member – Association of Zoologists of India (AZI)",
      "Life Member – Indian Association of Aquatic Biologists (IAAB)"
    ],

    profiles: {
      orcid: "0000-0002-2938-3610",
      scholar: "https://scholar.google.co.in/citations?user=9LyaOtwAAAAJ",
      vidwan: "450729"
    },

    profilePdf: "/zoology/NAGABHUSHAN.pdf"
  },
  {
    id: "zoo002",
    name: "Dr. Bandela Vijayudu",
    role: "Assistant Professor (C)",
    department: "Zoology",
    university: "Rayalaseema University, Kurnool",

    photo: "/zoology/bandela.JPG",
    email: "bandelavijay5@gmail.com",
    phone: "8374742791",

    dateOfBirth: "15-05-1986",
    dateOfJoining: "28-06-2017",

    qualification: "B.Sc. (BZC), M.Sc. Zoology, Ph.D.",

    about:
      "Dr. Bandela Vijayudu has over 7 years of teaching and research experience. His research interests include Developmental Biology, Cancer Biology, and Toxicology. He has published several papers in international journals and actively contributes to academic research and postgraduate mentoring.",

    education: [
      "B.Sc. (BZC) – Sri Krishnadevaraya University (2006)",
      "M.Sc. Zoology – Sri Venkateswara University (2008)",
      "Ph.D. – Sri Venkateswara University (2015)"
    ],

    specialization: [
      "Developmental Biology",
      "Cancer Biology",
      "Toxicology",
      "Oxidative Stress Biology"
    ],

    experience: {
      teaching: "7 Years 9 Months",
      research: "7 Years 9 Months"
    },

    publications: {
      journalsInternational: 9,
      journalsNational: 7,
      conferences: 0,
      booksChapters: 0,
      total: 16
    },

    publicationsList: [
      {
        year: 2023,
        title:
          "A Comparative Assessment of Specific Tumour Marker Levels in Blood",
        authors: "B. Vijayudu et al.",
        journal: "International Journal of Scientific Development and Research",
        type: "International",
        doi: "",
        link: ""
      }
    ],

    awards: [
      "Qualified APSET",
      "Qualified CSIR–UGC NET (AIR–118)"
    ],

    memberships: [
      "UGC BSR – RFSMS Fellow (2012–2015)"
    ],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/zoology/BANDELA.pdf"
  },
  {
  id: "zoo005",
  name: "Dr. Midde Venkata Chandrudu",
  role: "Assistant Professor",
  department: "Zoology",
  university: "Rayalaseema University, Kurnool",

  photo: "/zoology/chandra_profile1.png",
  email: "chandramidde4@gmail.com",
  phone: "9963735227",

  dateOfBirth: "15-07-1979",
  dateOfJoining: "27-07-2007",

  qualification: "B.Sc., B.Ed., M.Sc., Ph.D.",

  about:
    "Dr. Midde Venkata Chandrudu is an Assistant Professor in the Department of Zoology, Rayalaseema University, Kurnool. He has over 18 years of teaching and research experience. His research focuses on Ecotoxicology and Animal Physiology, particularly the effects of heavy metals and pesticides on aquatic organisms and environmental health. He has published extensively in national and international journals and actively contributes to research, teaching, and postgraduate project supervision.",

  education: [
    "B.Sc. – Sri Krishnadevaraya University, Anantapur (2000)",
    "B.Ed. – Sri Krishnadevaraya University, Anantapur (2001)",
    "M.Sc. – Sri Krishnadevaraya University, Anantapur (2003)",
    "Ph.D. – Sri Krishnadevaraya University, Anantapur (2006)"
  ],

  specialization: [
    "Ecotoxicology",
    "Animal Physiology",
    "Environmental Toxicology",
    "Aquatic Biology"
  ],

  experience: {
    teaching: "19 Years",
    research: "19 Years"
  },

  publications: {
    journalsInternational: 16,
    journalsNational: 4,
    conferences: 1,
    booksChapters: 1,
    total: 22
  },

  publicationsList: [
    {
      year: 2026,
      title:
        "Red grape seed extract attenuates D-galactose-induced neurotoxicity in pregnant rats: Evidence from the cerebral cortex and hippocampus",
      authors:
        "Gurumurthy V., Kanchan Chatterjee, Madan Mohan Rao V., Midde Venkata Chandrudu, Kamli Naik R., Sanjay Dey",
      journal: "Biochemical and Cellular Archives",
      type: "International",
      doi: "10.51470/bca.2026.26.1.467",
      link: "https://doi.org/10.51470/bca.2026.26.1.467"
    },
    {
      year: 2025,
      title:
        "Heavy metals and pesticide exposure in agricultural products and its adverse effects on human health: A review",
      authors: "Midde Venkata Chandrudu et al.",
      journal: "International Journal of Zoology and Applied Biosciences",
      type: "International",
      doi: "10.55126/ijzab.2025.v10.i06.028",
      link: "https://doi.org/10.55126/ijzab.2025.v10.i06.028"
    }
  ],

  awards: [
    "Patent Certificate of Registration of Design No. 461659-001 (2025) – AI Based Environmental Toxicity Detector",
    "Faculty Induction Programme – UGC HRDC, Osmania University (2021)",
    "Interdisciplinary Refresher Course – Ramanujan College, University of Delhi (2022)",
    "Faculty Development Programme – Teaching Learning Centre, Ramanujan College (2022)"
  ],

  memberships: [
    "Research Supervisor for M.Sc. Project Work",
    "Participant in National Symposium on Biotechnology – Trends & Perspectives"
  ],

  profiles: {
    orcid: "0009-0005-9342-3188",
    scholar: "https://scholar.google.com/citations?hl=en&user=waj-Z8QAAAAJ",
    vidwan: "453644"
  },

  achievements: [
    "Published 20 research papers",
    "Presented 7 research papers (6 National, 1 International)",
    "Guided 1 Ph.D. scholar",
    "Supervised M.Sc. dissertation projects for six batches",
    "Published one textbook on Animal Physiology"
  ],

  profilePdf: "/zoology/chandra-profile.pdf"
},
  {
    id: "zoo003",
    name: "Dr. R. Sreedhar",
    role: "Assistant Professor (C)",
    department: "Zoology",
    university: "Rayalaseema University, Kurnool",

    photo: "/zoology/sreedaer.JPG",
    email: "rayasamsreedhar@gmail.com",
    phone: "9492405600",

    dateOfBirth: "05-07-1980",
    dateOfJoining: "04-12-2017",

    qualification: "B.Sc., B.Ed., M.Sc., Ph.D.",

    about:
      "Dr. R. Sreedhar has over 8 years of teaching and research experience. His academic interests include Environmental Biology, Aquatic Ecology, and water quality assessment. He has published research papers in international journals and actively participates in academic programs.",

    education: [
      "B.Sc., B.Ed – Sri Krishnadevaraya University (2001, 2005)",
      "M.Sc. – Sri Venkateswara University (2007)",
      "Ph.D. – Sri Krishnadevaraya University (2016)"
    ],

    specialization: [
      "Environmental Biology",
      "Aquatic Ecology",
      "Water Quality Assessment"
    ],

    experience: {
      teaching: "8 Years",
      research: "8 Years"
    },

    publications: {
      journalsInternational: 2,
      journalsNational: 0,
      conferences: 0,
      booksChapters: 0,
      total: 2
    },

    publicationsList: [
      {
        year: 2023,
        title:
          "Assessment of physicochemical water quality of B. Thandrapadu Tank",
        authors: "R. Sreedhar",
        journal: "International Journal of Science and Research",
        type: "International",
        doi: "",
        link: ""
      }
    ],

    awards: [
      "To excel in the field of science by working on aggressive, yet united team and create a result-oriented environment, which would enhance scientific skills and aid performing to the best of one’s capabilities."
    ],

    memberships: [],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/zoology/sreedaer.pdf"
  }

  ,
  //botony faculty profiles can be added here
  /* =====================================================
      Dr. Bharath Kumar Ravuru
   ===================================================== */
  {
    id: "bot001",
    name: "Dr. Bharath Kumar Ravuru",
    role: "Professor & Head",
    department: "Botany",
    university: "Rayalaseema University, Kurnool",

    photo: "/botany/bharath.JPG",
    email: "drbharathravuru@gmail.com",
    phone: "8500722075",

    dateOfBirth: "01-06-1971",
    dateOfJoining: "07-02-2018",

    qualification: "B.Sc., M.Sc. (Plant Biotechnology), Ph.D. (Ethnobotany)",

    about:
      "Dr. Bharath Kumar Ravuru is a senior academician and researcher with extensive expertise in Plant Biotechnology, Ethnobotany, and Forest Ecology. He has guided doctoral scholars and contributed significantly to biodiversity, ethnomedicinal, and biotechnological research.",

    education: [
      "B.Sc. – Sri Venkateswara University",
      "M.Sc. Botany (Plant Biotechnology) – Sri Venkateswara University",
      "Ph.D. (Ethnobotany) – Sri Venkateswara University"
    ],

    specialization: [
      "Plant Biotechnology",
      "Ethnobotany",
      "Forest Ecology"
    ],

    experience: {
      teaching: "19 Years",
      research: "22 Years"
    },

    publications: {
      journalsInternational: 49,
      journalsNational: 20,
      conferences: 9,
      booksChapters: 2,
      total: 80
    },

    publicationsList: [
      {
        year: 2021,
        title: "Ethnobotanical survey of medicinal plants used by local tribes of Eastern Ghats",
        authors: "R. Bharath Kumar et al.",
        journal: "Journal of Ethnopharmacology",
        type: "International",
        doi: "",
        link: ""
      }
    ],

    awards: [
      "Theophrastus National Academic Excellence Award – 2021"
    ],

    memberships: [
      "Life Member – Indian Science Congress Association",
      "Member – New York Academy of Sciences"
    ],

    profiles: {
      orcid: "0000-0002-1385-0798  ",
      scholar: "https://scholar.google.com/citations?hl=en&user=8_4zqj0AAAAJ",
      vidwan: "209096 "
    },

    profilePdf: "/botany/bharath.pdf"
  }
  ,

  /* =====================================================
     Dr. G. Sri Ranganayakulu
  ===================================================== */
  {
    id: "bot002",
    name: "Dr. Guneti Sri Ranganayakulu",
    role: "Assistant Professor",
    department: "Botany",
    university: "Rayalaseema University, Kurnool",

    photo: "/botany/ranga.JPG",
    email: "gsranganaayakulu@gmail.com",
    phone: "9989239242",

    dateOfBirth: "05-09-1975",
    dateOfJoining: "01-07-2007",

    qualification: "B.Sc., M.Sc., Ph.D. (Botany)",

    about:
      "Dr. Guneti Sri Ranganayakulu specializes in Plant Physiology and Molecular Biology with research focus on abiotic stress tolerance and gene expression in crops.",

    education: [
      "B.Sc. – Sri Krishnadevaraya University",
      "M.Sc. Botany – Sri Krishnadevaraya University",
      "Ph.D. Botany – Sri Krishnadevaraya University"
    ],

    specialization: [
      "Plant Physiology",
      "Molecular Biology",
      "Stress Biology"
    ],

    experience: {
      teaching: "18 Years",
      research: "18 Years"
    },

    publications: {
      journalsInternational: 14,
      journalsNational: 12,
      conferences: 13,
      booksChapters: 2,
      total: 41
    },

    publicationsList: [
      {
        year: 2012,
        title: "Identification of drought stress responsive genes in groundnut",
        authors: "G. S. Ranganayakulu et al.",
        journal: "Acta Physiologia Plantarum",
        type: "International",
        doi: "",
        link: ""
      }
    ],

    awards: [
      "Associated Fellow – Andhra Pradesh Akademi of Sciences"
    ],

    memberships: [
      "Editorial Member – JBBBS",
      "Convener – Microbial Society of India"
    ],

    profiles: {
      orcid: "",
      scholar: "",
      vidwan: ""
    },

    profilePdf: "/botany/ranga.pdf"
  }

  ,

  /* =====================================================
     Dr. K. Venkata Ratnam
  ===================================================== */
  {
    id: "bot003",
    name: "Dr. K. Venkata Ratnam",
    role: "Assistant Professor (C)",
    department: "Botany",
    university: "Rayalaseema University, Kurnool",

    photo: "/botany/venkataramanabotony.JPG",
    email: "drvenkatapkd@gmail.com",
    phone: "8008497926",

    dateOfBirth: "20-12-1973",
    dateOfJoining: "06-08-2015",

    qualification: "B.Sc., M.Sc., M.Phil., Ph.D.",

    about:
      "Dr. K. Venkata Ratnam is an expert in ethnobotany, plant taxonomy, microbiology, and medicinal plants with extensive research output.",

    education: [
      "B.Sc. – Sri Krishnadevaraya University",
      "M.Sc. Botany – Sri Venkateswara University",
      "M.Phil – Sri Krishnadevaraya University",
      "Ph.D. – Sri Krishnadevaraya University"
    ],

    specialization: [
      "Ethnobotany",
      "Plant Taxonomy",
      "Microbiology",
      "Medicinal Plants"
    ],

    experience: {
      teaching: "18 Years",
      research: "18 Years"
    },

    publications: {
      journalsInternational: 30,
      journalsNational: 7,
      conferences: 4,
      booksChapters: 19,
      total: 60
    },

    publicationsList: [
      {
        year: 2024,
        title: "Tree diversity and documentation of Rayalaseema University",
        authors: "K. Venkata Ratnam et al.",
        journal: "African Journal of Biological Sciences",
        type: "International",
        doi: "",
        link: ""
      }
    ],

    profiles: {
      orcid: "0000- 0002-8677 - 1345 ",
      scholar: "https://scholar.google.com/citations?user=49a4jKoAAAAJ&hl=en",
      vidwan: ""
    },

    profilePdf: "/botany/VENKATA.pdf"
  }

  ,

  /* =====================================================
     Dr. B. Kavitha
  ===================================================== */
  {
    id: "bot004",
    name: "Dr. B. Kavitha",
    role: "Assistant Professor (C)",
    department: "Botany",
    university: "Rayalaseema University, Kurnool",

    photo: "/botany/kavitha.JPG",
    email: "kavithab15@gmail.com",
    phone: "7981750450",

    dateOfBirth: "05-04-1980",
    dateOfJoining: "02-09-2015",

    qualification: "B.Sc., M.Sc., M.Phil., Ph.D.",

    about:
      "Dr. B. Kavitha is an accomplished academician specializing in Phytomedicine, Pharmacognosy, and Nano-biotechnology.",

    education: [
      "B.Sc. & B.Ed – Sri Krishnadevaraya University",
      "M.Sc. Botany – Sri Krishnadevaraya University",
      "M.Phil – Sri Venkateswara University",
      "Ph.D. Botany – Sri Venkateswara University"
    ],

    specialization: [
      "Phytomedicine",
      "Pharmacognosy",
      "Medicinal Plants",
      "Nano-biotechnology"
    ],

    experience: {
      teaching: "22 Years",
      research: "22 Years"
    },

    publications: {
      journalsInternational: 26,
      journalsNational: 0,
      conferences: 3,
      booksChapters: 9,
      total: 38
    },

    publicationsList: [
      {
        year: 2024,
        title: "Hydroponic propagation of selected micro greens",
        authors: "B. Kavitha et al.",
        journal: "African Journal of Biological Sciences",
        type: "International",
        doi: "10.33472/AFJBS.6.13.2024.1369-1379",
        link: "https://doi.org/10.33472/AFJBS.6.13.2024.1369-1379"
      }
    ],

    awards: [
      "Women Researcher Award – 2021",
      "Best Teacher Award – Rotary Club"
    ],

    memberships: [
      "Life Member – Indian Science Congress Association",
      "Life Member – Botanical Society of India"
    ],

    profiles: {
      orcid: "0000-0002-0620-3664 ",
      scholar: "https://scholar.google.co.in/citations?user=roDQMz0AAAAJ&hl=en",
      vidwan: "317871"
    },

    profilePdf: "/botany/KAVITHA.pdf"
  }
  ,
  {
    id: "cs001",
    name: "Dr. Gormanukonda Ravi Kumar",
    role: "Assistant Professor & Coordinator",
    department: "Computer Science",
    university: "Rayalaseema University, Kurnool",

    photo: "/computerscience/ravi.JPG",
    email: "grkondaravi@gmail.com",
    phone: "8555919531",

    dateOfBirth: "10-07-1972",
    dateOfJoining: "01-09-2006",

    qualification: "B.Sc., MCA, M.Phil., M.Tech., Ph.D.",

    about:
      "Dr. Gormanukonda Ravi Kumar is a senior academician with over 23 years of teaching and research experience. His expertise includes Machine Learning, Software Engineering, and Big Data Analytics. He has guided a large number of Ph.D. scholars and handled funded research projects. He actively contributes as a reviewer, BOS member, and researcher in AI and data-driven systems.",

    education: [
      "B.Sc – Sri Krishnadevaraya University (1992)",
      "MCA, M.Phil, M.Tech – Sri Krishnadevaraya University (2001, 2009, 2020)",
      "Ph.D – Sri Krishnadevaraya University (2014)"
    ],

    specialization: [
      "Machine Learning",
      "Software Engineering",
      "Big Data Analytics"
    ],

    experience: {
      teaching: "23 Years",
      research: "23 Years"
    },

    publications: {
      journalsInternational: 24,
      journalsNational: 0,
      conferences: 20,
      booksChapters: 6,
      total: 50
    },

    publicationsList: [
      {
        year: 2024,
        title:
          "Multiclass date fruit prediction using SVM and logistic regression with OVO and OVR",
        authors: "Ravi Kumar G., Thippanna G., Venkateswarlu M.",
        journal: "Journal of Big Data Technology and Business Analytics",
        type: "International",
        doi: "",
        link: "https://matjournals.net/engineering/index.php/JBDTBA/article/view/1092/1572"
      }
    ],

    awards: [
      "Ideal Teaching Award Programme – 2019",
      "Assistant Professor of the Year – Tutors Pride, Hyderabad"
    ],

    memberships: [
      "Member – International Association of Engineers (IAENG)",
      "BOS Member – SSGS Degree College, Guntakal",
      "BOS Member – Silver Jubilee Government College, Kurnool",
      "BOS Member – KVR Government College (W), Kurnool"
    ],

    profiles: {
      orcid: "0000-0001-6977-2234",
      scholar: "https://scholar.google.co.in/citations?hl=en&user=ffQ6JWAAAAAJ",
      vidwan: "611140"
    },

    profilePdf: "/computerscience/GORMANUKONDA.pdf"
  }
  ,
  {
    id: "cs002",
    name: "Dr. Kancherla Nagamani",
    role: "Assistant Professor",
    department: "Computer Science",
    university: "Rayalaseema University, Kurnool",

    photo: "/computerscience/nagamani.JPG",
    email: "kancharlamani@gmail.com",
    phone: "9397088071",

    dateOfBirth: "01-06-1981",
    dateOfJoining: "09-2006",

    qualification: "B.Sc., M.Sc.(CS), Ph.D.",

    about:
      "Dr. Kancherla Nagamani is an experienced faculty member specializing in Computer Networks and MANETs. She has guided Ph.D. scholars and contributed significantly to research publications, conferences, and curriculum development.",

    education: [
      "B.Sc – Sri Krishnadevaraya University (2004)",
      "M.Sc (CS) – SKU PG Centre (2006)",
      "Ph.D – Rayalaseema University (2016)"
    ],

    specialization: [
      "Computer Networks",
      "MANETs"
    ],

    experience: {
      teaching: "18 Years",
      research: "18 Years"
    },

    publications: {
      journalsInternational: 13,
      journalsNational: 0,
      conferences: 11,
      booksChapters: 3,
      total: 27
    },

    awards: [
      "National Award of Excellence – 2019"
    ],

    profiles: {
      orcid: "0009-0005-5679-9071",
      scholar: "https://scholar.google.co.in/citations?user=7-G1eAAAAAJ",
      vidwan: "611139"
    },

    profilePdf: "/computerscience/KANCHERLA.pdf"
  }
  ,
  {
    id: "cs003",
    name: "Dr. M. Rajeswari",
    role: "Assistant Professor (C)",
    department: "Computer Science",
    university: "Rayalaseema University, Kurnool",

    photo: "/computerscience/rajeshwari.JPG",
    email: "rajeswarirucs@gmail.com",
    phone: "9398342174",

    dateOfBirth: "23-06-1982",
    dateOfJoining: "04-10-2006",

    qualification: "B.C.A, M.Sc.(CS), Ph.D.",

    about:
      "Dr. M. Rajeswari has extensive experience in Computer Networks and MANETs. She actively contributes to student training, placement support, hostel administration, and curriculum development.",

    education: [
      "B.C.A – Sri Krishnadevaraya University (2002)",
      "M.Sc (CS) – Sri Krishnadevaraya University (2006)",
      "Ph.D – Rayalaseema University (2017)"
    ],

    specialization: [
      "Computer Networks",
      "MANETs"
    ],

    experience: {
      teaching: "19 Years",
      research: "19 Years"
    },

    publications: {
      journalsInternational: 4,
      journalsNational: 2,
      conferences: 0,
      booksChapters: 0,
      total: 6
    },

    publicationsList: [
      {
        year: 2020,
        title:
          "Machine learning algorithms on taxonomy of heart disease",
        authors: "Nagesh Y., Rajeswari M.",
        journal: "International Journal of Applied Engineering Research",
        type: "International",
        doi: "",
        link: "https://www.ripublication.com/ijaer20/ijaerv15n1_11.pdf"
      }
    ],

    awards: [
      "Successfully conducted ICT courses for Arts and Science students, enhancing digital literacy and technical skills",
      "Active member of the Anti-Ragging Committee, ensuring a safe and supportive campus environment",
      "Currently serving as the Girls' Hostel Warden, overseeing student welfare, hostel administration, and discipline",
      "Provides placement support for MCA and Computer Science students through training sessions, workshops, and industry interactions",
      "Trained students in Advanced Java and Oracle, guiding research projects and internships",
      "Actively involved in curriculum development aligned with industry trends and technologies",
      "Works closely with corporate partners and recruiters for campus placements and internships"
    ],

    memberships: [],


    profilePdf: "/computerscience/RAJESWARI.pdf"
  },
  {
    id: "cs004",
    name: "Dr. Manda Vijay Kumar Naidu",
    role: "Assistant Professor (C)",
    department: "Computer Science",
    university: "Rayalaseema University, Kurnool",

    photo: "/computerscience/mandavijaykumarnaidu.JPG",
    email: "mandavijaykumar40@gmail.com",
    phone: "8639780283",

    dateOfBirth: "18-06-1984",
    dateOfJoining: "06-08-2015",

    qualification: "B.Sc.(CS), MCA, Ph.D.",

    about:
      "Dr. Manda Vijay Kumar Naidu specializes in Generative Artificial Intelligence and AI-based educational systems. He has contributed to research in AI, cybersecurity, and student mental health support through expert systems.",

    education: [
      "B.Sc (Computer Science) – SV University (2007)",
      "MCA – Anna University (2010)",
      "Ph.D  – Dravidian University (2025)"
    ],

    specialization: [
      "Generative Artificial Intelligence",
      "Web Technologies"
    ],

    experience: {
      teaching: "12+ Years",
      industry: "2 Years",
      total: "12 Years"
    },

    publications: {
      journalsInternational: 2,
      journalsNational: 0,
      conferences: 2,
      booksChapters: 1,
      total: 5
    },

    publicationsList: [
      {
        year: 2019,
        title:
          "A research threshold efficient hybrid encryption schema for secure file system",
        authors: "Penchalaiah P., Kumar M.V., Reddy K.R.",
        journal: "International Journal of Recent Technology and Engineering",
        type: "International",
        doi: "10.35940/ijrte.B1167.0782S319",
        link: "https://doi.org/10.35940/ijrte.B1167.0782S319"
      }
    ],

    awards: [
      "UGC NET & APSET Qualified – National and State level eligibility for Assistant Professorship",
      "APPSC Assistant Professor Screening Test – Top 10 in Andhra Pradesh",
      "Assistant Professor at Rayalaseema University (Since 2015) – Teaching AI, Data Structures, and Design & Analysis of Algorithms",
      "Developed a Web Application for CDC – Rayalaseema University",
      "Designed an AI-based Psychology Counseling Expert System for University Students",
      "IQAC-Technical support",
      "University website-Maintanence"
    ],

    memberships: [],


    profiles: {
      orcid: "0009-0002-3733-9318",
      vidwan: "611055"
    },

    profilePdf: "/computerscience/MANDA.pdf"
  },
  {
    id: "com001",
    name: "Dr. N. Moses",
    role: "Co-ordinator & Assistant Professor (C)",
    department: "Commerce",
    university: "Rayalaseema University, Kurnool",

    photo: "/commerce/moses.JPG",
    email: "drmosesknl@gmail.com",
    phone: "9885499307",

    dateOfBirth: "22-06-1982",
    dateOfJoining: "23-08-2013",

    qualification: "M.Com, MBA (Finance), NET, SET, Ph.D.",

    about:
      "Dr. N. Moses is a senior academician with over 18 years of combined teaching and industry experience. His core areas include Finance, Digital Payments, Financial Derivatives, and Business Analytics. He has held several university administrative positions and contributed extensively to research, curriculum development, and academic leadership.",

    education: [
      "B.Com (CA) – Sri Krishnadevaraya University (2004)",
      "M.Com – Sri Krishnadevaraya University (2006)",
      "Ph.D – Sri Krishnadevaraya University (2013)"
    ],

    specialization: [
      "Finance",
      "Digital Payments",
      "Financial Derivatives",
      "Business Analytics"
    ],

    experience: {
      teaching: "14 Years",
      research: "10+ Years",
      industry: "4 Years"
    },

    publications: {
      journalsInternational: 5,
      journalsNational: 2,
      conferences: 8,
      booksChapters: 3,
      total: 18
    },

    publicationsList: [],

    awards: [
      "Qualified UGC-NET",
      "Qualified APSET",
      "Outstanding Employee Award – S&P Capital IQ",
      "Best Rank Holder – B.Com (CA)"
    ],

    memberships: [
      "Member – Board of Studies (UG & PG), KVR Govt. College",
      "Member – Board of Studies, Govt. Degree College for Men, Kurnool"
    ],

    profiles: {
      orcid: "0009-0006-0711-9655",
      scholar: "https://scholar.google.com/citations?user=VhhjtN0AAAAJ",
      vidwan: "454527"
    },

    profilePdf: "/commerce/moses.pdf"
  }
  ,
  {
    id: "com002",
    name: "Dr. V. V. L. Leelakumari",
    role: "Assistant Professor (C)",
    department: "Commerce",
    university: "Rayalaseema University, Kurnool",

    photo: "/commerce/leelakumari.JPG",
    email: "leelakotika@gmail.com",
    phone: "9885492845",

    dateOfBirth: "15-04-1967",
    dateOfJoining: "19-08-2012",

    qualification: "M.Com, Ph.D.",

    about:
      "Dr. V. V. L. Leelakumari is a senior faculty member with over 35 years of teaching experience in Commerce. Her specialization includes Finance and Accounting. She has guided several Ph.D. scholars and published extensively in national and international journals.",

    education: [
      "B.Com – Sri Venkateswara University (1987)",
      "M.Com – Sri Venkateswara University (1989)",
      "Ph.D – Sri Krishnadevaraya University (2009)"
    ],

    specialization: [
      "Finance",
      "Accounting"
    ],

    experience: {
      teaching: "35 Years",
      research: "20+ Years"
    },

    publications: {
      journalsInternational: 4,
      journalsNational: 0,
      conferences: 3,
      booksChapters: 12,
      total: 19
    },

    publicationsList: [],

    awards: [
      "Best Teacher Award – 2017"
    ],

    memberships: [
      "Life Member – Indian Commerce Association"
    ],

    profiles: {
      orcid: "0000-0003-2372-0214",
      scholar: "",
      vidwan: ""
    },

    profilePdf: "/commerce/leela.pdf"
  }
  ,
  {
    id: "com003",
    name: "Dr. R. Bharathi",
    role: "Teaching Assistant",
    department: "Commerce",
    university: "Rayalaseema University, Kurnool",

    photo: "/commerce/bharathi.JPG",
    email: "bharathi@gmail.com",
    phone: "9441657691",
    dateOfBirth: "01-07-1974",
    dateOfJoining: "08-08-2013",

    qualification: "M.Com, Ph.D.",

    about:
      "Dr. R. Bharathi is a Teaching Assistant in the Department of Commerce with experience in Commerce and Management Studies. She actively supports undergraduate and postgraduate teaching activities.",

    specialization: [
      "Commerce",
      "Management Studies"
    ],

    experience: {
      teaching: "23+ Years"
    },

    publications: {
      journalsInternational: 5,
      journalsNational: 10,
      conferences: 15,
      booksChapters: 0,
      total: 30
    },
    awards: [
      "ICSSR Sponsored 2-week Capacity Building Programme on 'Research Methodology, Data Analysis using SPSS and Academic Writing' – Dept. of Management Studies, Rayalaseema University (11–23 March 2019)",
      "Faculty Development Programme – Dept. of Management Studies, SV University, Tirupati",
      "Participated in 5 International Webinars",
      "Participated in 5 National Webinars",
      "Participated in National Level Symposium",
      "Worked as Anti-Ragging Squad Team Member – Women’s Hostel, RU Campus (2024–2025)",
      "Monitoring Committee Member for PG II Semester Theory Examinations – Rayalaseema University",
      "Co-convener of VIGNAN-2019 – District Level Programme for RU Affiliated PG Colleges",
      "Observer for Rayalaseema University PG Examinations – Osmania Degree College",
      "Project Examiner for PG Examinations – KVR PG College, Kurnool",
      "Observer for Rayalaseema University PG Examinations – Sai MBA College, Nandikotkur"
    ],

    memberships: [],


    publicationsList: [],

    profiles: {},

    profilePdf: "/commerce/barathi.pdf"
  }
  ,
  {
    id: "com004",
    name: "Dr. M. Yugandharudu",
    role: "Assistant Professor (C)",
    department: "Commerce",
    university: "Rayalaseema University, Kurnool",

    photo: "/commerce/yugandarudu.JPG",
    email: "m.yugandhar12@gmail.com",
    phone: "8374348953",

    dateOfBirth: "01-07-1972",
    dateOfJoining: "01-11-2017",

    qualification: "M.Com, Ph.D.",

    about:
      "Dr. M. Yugandharudu has over 26 years of teaching experience with specialization in Rural Industrialization, Entrepreneurship, and Digital Payments. He has actively participated in national and international conferences and faculty development programs.",

    education: [
      "B.Com – S.K. University",
      "M.Com – Sri Venkateswara University",
      "Ph.D – Rayalaseema University"
    ],

    specialization: [
      "Entrepreneurship",
      "Rural Industrialization",
      "Digital Payments"
    ],

    experience: {
      teaching: "26 Years",
      research: "15+ Years"
    },

    publications: {
      journalsInternational: 5,
      journalsNational: 7,
      conferences: 5,
      booksChapters: 0,
      total: 17
    },

    publicationsList: [],

    awards: [
      "Great Guru Spandana Teacher Award & Certificate of Appreciation – Spandana Eda International Foundation (12-12-2021)",

      "ACHARYA 4.0 Faculty Development Programme on Entrepreneurship – Atal Incubation Centre, S.K. University, Ananthapur (5–7 Sept 2022)",
      "Online FDP on ICT Tools for Teaching, Learning Process and Institute – Felectronics & ICT Academies, MeitY, Govt. of India (15–26 March 2021)",
      "FDP on Writing and Publishing Research Articles in Social Sciences & Digital E-Learning – Sanskrithi Group of Institutions (20 March 2020)",
      "ICSSR Sponsored 2-week Capacity Building Programme on Research Methodology, Data Analysis using SPSS & Academic Writing – Rayalaseema University (11–23 March 2019)",

      "Two-Day International Webinar on Entrepreneurship Development Orientation & Digital Transformation – NFED Business Facilitators Forum & International Partners (6–7 Aug 2021)",

      "National Webinar on Financial Education – A Life Skill under NEP 2020 – Jinvani Management College & AMFI (10 Dec 2024)",
      "National Webinar on FinTech: Where It Is and Where It Is Going – St. Joseph’s Degree College, Kurnool (25 June 2022)",
      "National Webinar on Women Entrepreneurship – Emerging Issues & Challenges – Govt. College for Men, Kurnool (06 Aug 2021)",
      "National Webinar on Investment Avenues in Pandemic Era – St. Joseph’s Degree College & Geojit (22 June 2021)",
      "Two-Day National Webinar on Research Structuring, Statistical Insights & Publication Strategies – NFEFD (24–25 July 2021)",

      "National Level Symposium FINNOV-2019 – MBA Editorial Book Chapters (Sanskrithi School of Business)",

      "Anti-Ragging Squad Member – Men’s Hostel, RU Campus (2024–2025)",
      "In-charge for Painting Event – HAR GHAR TIRANGA Programme, Rayalaseema University (10 Aug 2022)",
      "Monitoring Committee Member – PG II Semester Examinations (Jan 2021)",
      "Route Officer – APSET 2021 Examination",
      "Examiner – PG III Semester Valuation, Rayalaseema University (Dec 2019)",
      "Anti-Ragging Squad Member – Men’s Hostel, RU Campus (2019)",
      "Co-convener – VIGNAN-2019 District Level Programme",
      "Observer – Rayalaseema University PG Examinations (2019)",
      "Observer – RU DDE UG Examinations",
      "Anti-Ragging Squad Member – RU Campus (2018)",
      "Stage Management Committee – Fresher’s Day cum Orientation Programme (29 Sept 2018)",
      "Internal Examiner – M.Com IV Semester Project Viva-Voce (19 April 2018)",
      "Observer – Silver Jubilee Govt. Degree College, Kurnool (27 Nov 2018)"
    ],

    memberships: [],


    profiles: {
      orcid: "0009-0006-2499-526X",
      scholar: "",
      vidwan: ""
    },

    profilePdf: "/commerce/yugandarudu.pdf"
  }
  ,
  {
    id: "bm000",
    name: "Dr. C. Viswanatha Reddy",
    role: "Professor & Head",
    department: "Business Management",
    university: "Rayalaseema University, Kurnool",

    photo: "/businessmanagement/prof vishwanath reddy.png",
    email: "vsrits@gmail.com",
    phone: "9848263463",

    qualification: "M.Com., MBA, M.Phil., Ph.D.",

    about:
      "Dr. C. Viswanatha Reddy is a senior academician with extensive experience in teaching, research, and academic administration. His expertise includes Finance, Accounting, Quantitative Techniques, and Predictive Analytics. He has guided research scholars and contributed significantly to management education and institutional development.",

    specialization: [
      "Finance",
      "Accounting",
      "Quantitative Techniques",
      "Predictive Analytics"
    ],

    experience: {
      teaching: "25+ Years",
      research: "20+ Years"
    },

    publications: {
      journalsInternational: 0,
      journalsNational: 0,
      conferences: 0,
      booksChapters: 0,
      total: 0
    },

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/businessmanagement/C-VISWANATHA-REDDY.pdf"
  },

  {
    id: "bm001",
    name: "Dr. P. Nagaraju",
    role: "Assistant Professor (MTS)",
    department: "Business Management",
    university: "Rayalaseema University, Kurnool",

    photo: "/businessmanagement/pnagarajuprofilephoto.JPG",
    email: "drpnagaraju6@gmail.com",
    phone: "9441193329",
    dateOfBirth: "16-06-1973 ",
    dateOfJoining: "14-02-2005 ",

    qualification: "M.B.A., Ph.D., UGC-NET",

    specialization: [
      "Management Studies"
    ],

    experience: {
      teaching: "19  Years",
      research: "19 Years"
    },

    publications: {
      journalsInternational: 4,
      journalsNational: 0,
      conferences: 14,
      booksChapters: 1,
      total: 19
    },
    awards: [
      "Qualified in UGC NET in Management (December 1999)",
      "One Ph.D awarded under my guidance",
      "Resource Person to APITCO"
    ],

    memberships: [
      "UGC Major Research Project Fellow – 'Telecom Sector Reforms in India' (2003–2005)"
    ]
    ,
    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/businessmanagement/mbanagarajusirupdatedprofile.pdf"
  },

  // {
  //   id: "bm002",
  //   name: "Dr. Rama Krishna Godha",
  //   role: "Assistant Professor (C)",
  //   department: "Business Management",
  //   university: "Rayalaseema University, Kurnool",

  //   photo: "/businessmanagement/ramakrishna.JPG",
  //   email: "drgrkrishna@gmail.com",
  //   phone: "9951422499",

  //   dateOfBirth: "14-07-1973",
  //   dateOfJoining: "14-07-2002",

  //   qualification: "B.Sc., M.B.A., Ph.D.",

  //   specialization: [
  //     "Banking Sector",
  //     "Finance"
  //   ],

  //   experience: {
  //     teaching: "26 Years",
  //     research: "20+ Years"
  //   },

  //   publications: {
  //     journalsInternational: 8,
  //     journalsNational: 21,
  //     conferences: 12,
  //     booksChapters: 3,
  //     total: 44
  //   },

  //   profiles: {
  //     orcid: "0009-0007-9364-9130",
  //     scholar: "https://scholar.google.com/citations?hl=en&user=BOuuC6gAAAAJ",
  //     vidwan: "449387"
  //   },

  //   profilePdf: "/businessmanagement/rama.pdf"
  // },

  {
    id: "bm003",
    name: "Dr. Pagadala Suchitra",
    role: "Assistant Professor (C)",
    department: "Business Management",
    university: "Rayalaseema University, Kurnool",

    photo: "/businessmanagement/sucharith.JPG",
    email: "svijay1820@gmail.com",
    phone: "9848747421",

    dateOfBirth: "18-06-1974",
    dateOfJoining: "06-08-2015",
    qualification: "B.A., M.B.A., Ph.D.",

    specialization: [
      "Human Resource Management",
      "Marketing Management"
    ],

    experience: {
      teaching: "24 Years",
      research: "20+ Years"
    },

    publications: {
      journalsInternational: 18,
      journalsNational: 3,
      conferences: 8,
      total: 29
    },
    awards: [
      "Recipient of Prof. K. Venkat Reddy Gold Medal at MBA level for standing first",
      "Associated with SEBI as Certified Financial Education Resource Person",
      "Certified Master Trainer for English Communication Skills Project (APSCHE & British Council)",
      "Served as RU Women’s Hostel Deputy Warden (Aug 2018 – March 2022)",
      "Served as Coordinator in RU Exam Section (18 March 2022 – 19 Feb 2025)",
      "Attended 7 FDPs and 3 Training Programs",
      "Cleared 'Basics of Digital Marketing' course with 58% through SWAYAM (Aug 2022)"
    ],

    memberships: [
      "Member – AIMA (All India Management Association)"
    ]
    ,
    profiles: {
      orcid: "0000-0002-5264-7733",
      scholar: "https://scholar.google.co.in/citations?user=lGo9nYIAAAAJ",
      vidwan: "447474"
    },

    profilePdf: "/businessmanagement/sucharith.pdf"
  },

  {
    id: "bm004",
    name: "Dr. G. Renuka",
    role: "Assistant Professor",
    department: "Business Management",
    university: "Rayalaseema University, Kurnool",

    photo: "/businessmanagement/Renuka.JPG",
    email: "grenuka8@gmail.com",
    phone: "9440546546",

    dateOfBirth: "08-08-1977",
    dateOfJoining: "06-08-2015",
    qualification: "B.Com (Hons), M.Com, MBA, Ph.D.",

    specialization: [
      "Management Studies",
      "Entrepreneurship",
      "Finance"
    ],

    experience: {
      teaching: "21 Years",
      research: "21+ Years"
    },

    publications: {
      journalsInternational: 4,
      journalsNational: 8,
      conferences: 9,
      booksChapters: 1,
      total: 22
    },
    awards: [
      "School I Rank in 11th and 12th – Kendriya Vidyalaya (1993, 1994)",
      "First Rank in Sri Krishnadevaraya University – M.Com (2000)",
      "AP SET qualified in Management",
      "Completed 5 SWAYAM Courses (3 NPTEL + 2 ARPIT) – 2020-2021",
      "Attended 4 ATAL FDP Programmes – 2020-2021",
      "Coordinator for Innovation and Incubation & Centre for Entrepreneurship Development – Rayalaseema University",
      "Worked as Head of Department, Business Management – Rishi UBR PG College for Women",
      "Placement and Training In-charge – Rishi Group of Institutions (2 years)",
      "Faculty Member for Banking – ICICI Manipal Academy, Hyderabad",
      "ED Cell Member – ICBM Business School, Hyderabad",
      "MOOC: Do Your Venture – Women Start-up Programme, IIMB X NSRCEL (2017)",
      "FDP on Using Blended MOOCs in Management Education – IIM Bangalore (2016)"
    ],

    memberships: [
      "Member – Indian Science Congress"
    ]
    ,
    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/businessmanagement/renuka.pdf"
  },

  {
    id: "bm005",
    name: "Dr. Gunda Surendra",
    role: "Assistant Professor (C)",
    department: "Business Management",
    university: "Rayalaseema University, Kurnool",

    photo: "/businessmanagement/surendra.JPG",
    email: "surendragunda@gmail.com",
    phone: "9440717755",

    dateOfBirth: "20-01-1973",
    dateOfJoining: "06-08-2015",
    qualification: "M.B.A., Ph.D.",

    specialization: [
      "Business Management"
    ],

    experience: {
      teaching: "21+ Years",
      research: "8+ Years"
    },
    awards: ["Patent No. 202241039555 – Issue No. 29/2022 – 22 July 2022",
      "Patent No. 202241046435 – Issue No. 37/2022 – 16 September 2022"],

    memberships: [
      "Member – Indian Science Congress Association",
      "Associated with RUDSETI, Anantapuram",
      "Associated with APPC, Hyderabad",
      "Associated with APITCO, Kurnool"
    ],



    publications: {
      journalsInternational: 2,
      journalsNational: 2,
      conferences: 8,
      booksChapters: 9,
      total: 21
    },
    profiles: {
      scholar: "",
      orcid: "0009-0006-7267-0849",
      vidwan: "453054"
    },

    profilePdf: "/businessmanagement/gunda.pdf"
  }
  ,


  /* =====================================================
     Prof. Venkata Sundaranand Putcha
  ===================================================== */
  {
    id: "math001",
    name: "Prof. Venkata Sundaranand Putcha",
    role: "Professor & Head",
    department: "Mathematics",
    university: "Rayalaseema University, Kurnool",

    photo: "/mathematics/putcha1.JPG",
    email: "anand_putcha@yahoo.com",
    phone: "9848226855",

    qualification: "M.Sc., Ph.D.",

    about:
      "Prof. Venkata Sundaranand Putcha is a senior mathematician with more than 29 years of experience in teaching, research, consultancy, and academic leadership. His research interests include Applied Mathematics, Nonlinear Dynamical Systems, Cryptography, Control Theory, and Mathematical Ecology. He has served as Professor & Head of the Department of Mathematics and has guided Ph.D., M.Phil., and postgraduate scholars.",

    specialization: [
      "Applied Mathematics",
      "Nonlinear Dynamical Systems",
      "Cryptography & Cryptanalysis",
      "Mathematical Control Theory",
      "Mathematical Ecology"
    ],

    experience: {
      teaching: "29+ Years",
      research: "29+ Years"
    },

    publications: {
      journalsInternational: 25,
      journalsNational: 10,
      conferences: 10,
      booksChapters: 5,
      total: 50
    },

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/mathematics/VENKATA-SUNDARANAND-PUTCHA.pdf"
  },

  /* =====================================================
     Dr. M. Veera Krishna
  ===================================================== */
  {
    id: "math002",
    name: "Dr. M. Veera Krishna",
    role: "Assistant Professor (C)",
    department: "Mathematics",
    university: "Rayalaseema University, Kurnool",

    photo: "/mathematics/veerakrishna.JPG",
    email: "veerakrishna_maths@yahoo.com",
    phone: "9849650682",
    dateOfBirth: "04-06-1978 ",
    dateOfJoining: "01-10-2001 ",

    qualification: "M.Sc., M.Phil., Ph.D.",

    specialization: [
      "Applied Mathematics",
      "Fluid Mechanics",
      "Heat & Mass Transfer"
    ],

    experience: {
      teaching: "18+ Years",
      research: "15+ Years"
    },
    awards: [
      "Prof. R. Sitharamaswamy Endowment Prize for M.Sc. First Rank – S.K. University, Anantapur",
      "First Rank – RESCET 2003, S.K. University, Anantapur",
      "APSET Qualified – 2016",
      "Best Scientist Award – ICAPM 2018, Madurai Kamaraj University & IMRF",
      "World Scientist Rank for three consecutive years (2023, 2024, 2025) – India Rank 65, Asia Rank 351",
      "Top 2% Most Influential Scientists – 2023, Stanford University",
      "Editor – Journal of Nanofluids, American Scientific Publishers, USA (from 2021 till date)",
      "Worked as In-charge, Dept. of Mathematics (2009–2013) and Deputy Warden, Men’s Hostels (2023–2024)",
      "Published paper in Journal of Ocean Engineering and Science (Elsevier), Impact Factor 13 – https://doi.org/10.1016/j.joes.2019.05.002"
    ],

    memberships: [
      "Life Member – Indian Society of Theoretical and Applied Mechanics (ISTAM)"
    ],


    publications: {
      journalsInternational: 100,
      journalsNational: 16,
      conferences: 10,
      booksChapters: 6,
      total: 132
    },

    profiles: {
      scholar: "https://scholar.google.co.in/citations?hl=en&user=8aNYp7oAAAAJ",
      orcid: "0000-0002-6580-1592",
      vidwan: "451037"
    },

    profilePdf: "/mathematics/veerakrishna.pdf"
  },

  /* =====================================================
     Dr. S. V. Suneetha
  ===================================================== */
  {
    id: "math003",
    name: "Dr. S. V. Suneetha",
    role: "Assistant Professor (C)",
    department: "Mathematics",
    university: "Rayalaseema University, Kurnool",

    photo: "/mathematics/sunnetha.JPG",
    email: "sunithaknl17@gmail.com",
    phone: "9866945663",

    dateOfBirth: "06-08-1974",
    dateOfJoining: "15-08-2007",

    qualification: "B.Sc., MCA, Ph.D.",

    about:
      "Dr. S. V. Suneetha is an experienced academician with 18 years of teaching and research experience. Her specialization is Fluid Dynamics. She has published extensively in international journals and has guided Ph.D. scholars. She has also served in administrative roles including Deputy Warden and Department Coordinator.",

    specialization: [
      "Fluid Dynamics",
      "Applied Mathematics",
      "Computational Fluid Dynamics"
    ],

    experience: {
      teaching: "18 Years",
      research: "18 Years"
    },

    publications: {
      journalsInternational: 31,
      journalsNational: 10,
      conferences: 8,
      booksChapters: 0,
      total: 49
    },

    awards: [
      "Worked as Deputy Warden for Women’s Hostel – Rayalaseema University (2009–2020)",
      "Coordinator for the Department of Mathematics – Rayalaseema University (2016–2017)",
      "Designed and delivered advanced postgraduate courses in Topology, Functional Analysis, Operator Theory, and Graph Theory",
      "Mentored and guided research scholars in mathematical modeling and computational mathematics",
      "Member – Anti-Ragging Committee, ensuring a safe and disciplined campus environment",
      "Women Protection Cell Coordinator – Promoted gender sensitization, women empowerment, and student safety",
      "Alumni Coordinator – Strengthened alumni relations and organized alumni networking events",
      "Recognized for outstanding contributions in student mentoring and hostel administration",
      "Organized workshops, conferences, and seminars at national and international levels",
      "Invited Speaker and Panelist at conferences on Fluid Dynamics and Mathematical Sciences",
      "Reviewer and Editorial Member for reputed mathematical journals",
      "Successfully guided multiple research scholars and postgraduate students in applied mathematics"
    ],

    memberships: [],


    profiles: {
      scholar: "https://scholar.google.co.in/citations?hl=en&user=k8cU7WgAAAAJ",
      orcid: "0009-0000-6362-867X ",
      vidwan: "611163 "
    },

    profilePdf: "/mathematics/suneetha.pdf"
  },

  /* =====================================================
     Dr. U. Nagi Reddy
  ===================================================== */
  {
    id: "math004",
    name: "Dr. U. Nagi Reddy",
    role: "Assistant Professor (C)",
    department: "Mathematics",
    university: "Rayalaseema University, Kurnool",

    photo: "/mathematics/Nagireddy.JPEG",
    email: "nagireddyppr@gmail.com",
    phone: "8106415164",

    dateOfBirth: "05-05-1987",
    dateOfJoining: "29-06-2017",

    qualification: "B.Sc., M.Sc. (Applied Mathematics), M.Phil., Ph.D.",

    specialization: [
      "Computer Networks",
      "MANETS",
      "Applied Algebra"
    ],

    experience: {
      teaching: "7 Years 8 Months",
      research: "7+ Years"
    },

    publications: {
      journalsInternational: 0,
      journalsNational: 0,
      conferences: 2,
      booksChapters: 0,
      total: 2
    },

    awards: [
      "Qualified APSET – 2021"
    ],

    profiles: {
      orcid: "0000-0003-4656-1404",
      scholar: "https://scholar.google.com/citations?user=Q2OpCfwAAAAJ",
      vidwan: "611377"
    },

    profilePdf: "/mathematics/nagireddy.pdf"
  },
  {
    id: "bio001",
    name: "Dr. G. V. Swarnalatha",
    role: "Assistant Professor (C)",
    department: "Biotechnology",
    university: "Rayalaseema University, Kurnool",

    photo: "/biotechnology/Dr.Swarnalatha.JPG",
    email: "venkata85722@gmail.com",
    phone: "8639514999",

    dateOfBirth: "10-06-1985",
    dateOfJoining: "28-06-2017",

    qualification: "M.Sc., Ph.D., CSIR-NET",

    about:
      "Dr. G. V. Swarnalatha is an Assistant Professor in Biotechnology with expertise in Algal Biochemistry. She has over 8 years of teaching and research experience and has published extensively in national and international journals. Her research focuses on microalgae, biofuels, stress physiology, and biotechnological applications.",

    education: [
      "B.Sc. – Sri Krishnadevaraya University (2006)",
      "M.Sc. Biochemistry – Yogi Vemana University (2008)",
      "Ph.D. Biochemistry – CSIR-CFTRI & University of Mysore (2017)"
    ],

    specialization: [
      "Algal Biochemistry",
      "Microalgal Biotechnology",
      "Stress Physiology"
    ],

    experience: {
      teaching: "8 Years 9 Months",
      research: "8+ Years"
    },

    publications: {
      journalsInternational: 3,
      journalsNational: 4,
      conferences: 18,
      booksChapters: 12,
      total: 37
    },

    awards: [
      "CSIR–JRF/NET Qualified",
      "Bronze Award – IECBBB International Conference (2020)",
      "Outstanding Women in PGPR Teaching Award – 2022"
    ],

    memberships: [
      "Life Member – Asian PGPR Society (USA)",
      "Member – Association of Food Scientists & Technologists (AFST)"
    ],

    profiles: {
      scholar: "https://scholar.google.com/citations?user=IWalNk8AAAAJ",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/biotechnology/Dr.Swarnalatha.pdf"
  },
  {
    id: "bio002",
    name: "Dr. K. Monika",
    role: "Assistant Professor (C)",
    department: "Biotechnology",
    university: "Rayalaseema University, Kurnool",

    photo: "/biotechnology/mounika.JPG",
    email: "monikasku.7@gmail.com",
    phone: "9440363555",

    dateOfBirth: "12-02-1983",
    dateOfJoining: "04-12-2017",

    qualification: "M.Sc., Ph.D.",

    about:
      "Dr. K. Monika is an Assistant Professor in Biotechnology with specialization in Microbiology and Bioinformatics. She has significant research contributions in molecular docking, enzymology, and computational biology, with several publications in high-impact international journals.",

    education: [
      "B.Sc. – Sri Krishnadevaraya University (2003)",
      "M.Sc. Microbiology – Sri Venkateswara University (2005)",
      "Ph.D. Microbiology – Sri Krishnadevaraya University (2011)"
    ],

    specialization: [
      "Microbiology",
      "Bioinformatics",
      "Molecular Docking",
      "Computational Biology"
    ],

    experience: {
      teaching: "8 Years",
      research: "8+ Years"
    },

    publications: {
      journalsInternational: 18,
      journalsNational: 0,
      conferences: 13,
      booksChapters: 0,
      total: 31
    },

    awards: [
      "Best Oral Presentation Award – Agri Nano Conference (2013)"
    ],

    memberships: [
      "Member – All India Microbiologists (AIM)",
      "Lifetime Member – Microbiologists Society of India"
    ],

    profiles: {
      scholar: "https://scholar.google.co.in/citations?user=h9RgK6cAAAAJ",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/biotechnology/mounika.pdf"
  }
  ,

  /* =====================================================
     Dr. C. V. Krishna Reddy
  ===================================================== */
  {
    id: "phy001",
    name: "Dr. C. V. Krishna Reddy",
    role: "Professor & Head",
    department: "Physics",
    university: "Rayalaseema University, Kurnool",

    photo: "/physics/cvkredd.JPG",
    email: "reddycvk02@yahoo.co.in",
    phone: "9989642920",
    dateOfBirth: "15-06-1966 ",
    dateOfJoining: "28-10-1992 ",

    qualification: "M.Sc., M.Phil., Ph.D.",

    about:
      "Dr. C. V. Krishna Reddy is a senior academician and researcher specializing in Solid State Spectroscopy. He has several years of teaching and research experience and has contributed to research in materials characterization and spectroscopic techniques.",

    specialization: [
      "Solid State Spectroscopy",
      "Materials Characterization",
      "Condensed Matter Physics"
    ],

    experience: {
      teaching: "33+ Years",
      research: "33+ Years"
    },
    awards: [
      "Qualified in Joint CSIR–UGC NET (1990)",
      "State Best University Teacher Award – Government of Andhra Pradesh (2017)",
      "Member, Board of Studies (BoS) for several Universities and Autonomous Colleges",
      "Regional Coordinator for LAWCET-2012 – Sri Venkateshwara University, Tirupati",
      "Judge – District Level INSPIRE Awards Exhibition, Dept. of School Education, Kurnool (25–27 June 2011)",
      "Member of Committee for granting Autonomous status to several Degree Colleges",
      "Principal – University College of Science (28-08-2021 to Dec 2025)",
      "Member – Executive Council, Rayalaseema University (since 22-02-2016)",
      "Rector – Rayalaseema University (01-02-2023 to 09-02-2024)",
      "Dean of Examinations – Rayalaseema University (29-11-2018 to 15-09-2019)",
      "Dean, College Development Council – Rayalaseema University (16-09-2019 to 27-08-2021 and 10-02-2024 to 04-05-2025)",
      "Principal – Rayalaseema University College of Engineering (14-03-2019 for five months)",
      "In-charge Registrar – Rayalaseema University",
      "Convener – RUPGCET-2017",
      "Head & Chairperson, BoS – Dept. of Physics, Rayalaseema University (2013 to till date)",
      "Director – Distance Education, Rayalaseema University (2011–2012)",
      "Controller of Examinations – Rayalaseema University (2010–2011)"
    ],

    memberships: [
      "Qualified in Joint CSIR–UGC NET (1990)"
    ],


    publications: {
      journalsInternational: 26,
      journalsNational: 5,
      conferences: 4,
      booksChapters: 0,
      total: 35
    },

    profiles: {
      scholar: "https://scholar.google.com/citations?view_op=list_works&hl=en&user=CC3yug8AAAAJ",
      orcid: "0000-0001-7091-5482  ",
      vidwan: "612810 "
    },

    profilePdf: "/physics/CV-KRISHNA-REDDY.pdf"
  },

  /* =====================================================
     Dr. G. K. Siva Sankara Yadav
  ===================================================== */
  {
    id: "phy002",
    name: "Dr. G. K. Siva Sankara Yadav",
    role: "Assistant Professor (C)",
    department: "Physics",
    university: "Rayalaseema University, Kurnool",

    photo: "/physics/yadav.JPG",
    email: "gkssyadav@gmail.com",
    phone: "9441510086",

    dateOfBirth: "23-06-1982",
    dateOfJoining: "24-11-2015",

    qualification: "M.Sc., M.Phil., Ph.D.",

    about:
      "Dr. G. K. Siva Sankara Yadav is an accomplished physicist specializing in Materials Science. He has extensive experience in teaching undergraduate and postgraduate courses and has published numerous research papers in reputed international journals. He has also served in important administrative roles including Assistant Director (Admissions) and Coordinator to the Dean of Examinations.",

    specialization: [
      "Materials Science",
      "Nanomaterials",
      "Solid State Physics"
    ],

    experience: {
      teaching: "16 Years",
      research: "16 Years"
    },

    publications: {
      journalsInternational: 13,
      journalsNational: 1,
      conferences: 7,
      booksChapters: 3,
      total: 24
    },

    awards: [
      "APTET Qualified",
      "Worked as Academic Assistant – J.N.T.U.A. College of Engineering, Pulivendula (Oct 2008 – Nov 2015)",
      "Served as Assistant Director – Directorate of Admissions, Rayalaseema University, Kurnool (15-03-2017 to 19-03-2022)",
      "Served as Coordinator to assist Dean of Examination – Rayalaseema University, Kurnool (19-03-2022 to 18-03-2023 and 21-08-2024 to 14-02-2025)"
    ],

    memberships: [],


    profiles: {
      orcid: "0000-0002-9591-3798",
      scholar: "https://scholar.google.com/citations?user=EeUwYTkAAAAJ",
      vidwan: "453893"
    },

    profilePdf: "/physics/GK-SIVA-SANKARA-YADAV.pdf"
  },

  /* =====================================================
     Dr. E. Rajasekhar
  ===================================================== */
  {
    id: "phy003",
    name: "Dr. E. Rajasekhar",
    role: "Assistant Professor (C)",
    department: "Physics",
    university: "Rayalaseema University, Kurnool",

    photo: "/physics/rajasekhar.JPG",
    email: "physics.rajasekhar@gmail.com",
    phone: "9985075726",

    dateOfBirth: "01-07-1979",
    dateOfJoining: "28-07-2016",

    qualification: "M.Sc., Ph.D.",

    about:
      "Dr. E. Rajasekhar is an Assistant Professor of Physics with specialization in Applied Physics and Electronics. His research includes nanomaterials, radiation physics, and biological applications of nanoparticles. He has published extensively in international journals and has actively participated in national and international conferences.",

    specialization: [
      "Applied Physics",
      "Electronics",
      "Nanomaterials",
      "Radiation Physics"
    ],

    experience: {
      teaching: "9 Years",
      research: "9 Years"
    },

    publications: {
      journalsInternational: 11,
      journalsNational: 2,
      conferences: 2,
      booksChapters: 1,
      total: 16
    },

    awards: [
      "CSIR–UGC NET Qualified",
      "GATE Qualified",
      "TS–SET Qualified"
    ],

    memberships: [
      "UGC–BSR Fellowship"
    ],

    profiles: {
      orcid: "0000-0001-6013-1414",
      scholar: "https://scholar.google.com/citations?user=11o_NYUAAAAJ",
      vidwan: "451267"
    },

    profilePdf: "/physics/RAJASEKHAR.pdf"
  },
  {
    id: "tel001",
    name: "Prof. N. Narasimhulu",
    role: "Professor & Head",
    department: "Telugu",
    university: "Rayalaseema University, Kurnool",

    photo: "/telugu/Narasimhulu.JPG",
    email: "drnnarasimhuluknl@gmail.com",
    phone: "9182034667",

    dateOfBirth: "10-06-1963",
    dateOfJoining: "20-03-1997",

    qualification: "M.A. (Telugu), M.Phil., Ph.D.",

    about:
      "Prof. N. Narasimhulu is a senior academician with more than 28 years of teaching and research experience in Telugu language and literature. His areas of specialization include Folk Literature and Classical Telugu studies. He has guided several Ph.D. scholars and served in various academic and administrative positions including Head of the Department, BOS Chairman, NSS Coordinator, Director of Academic Affairs, Research Director, and Dean of Examinations.",

    education: [
      "B.Sc. – Sri Venkateswara University (1985)",
      "M.A. Telugu – Sri Venkateswara University (1987)",
      "M.Phil. & Ph.D. – Sri Venkateswara University (1995)"
    ],

    specialization: [
      "Folk Literature",
      "Classical Telugu Literature"
    ],

    experience: {
      teaching: "28 Years",
      research: "28 Years"
    },

    publications: {
      journalsNational: 30,
      journalsInternational: 6,
      conferences: 30,
      booksChapters: 8,
      total: 74
    },

    awards: [
      "Head, Department of Telugu",
      "Dean of Examinations",

    ],

    memberships: [
      "Member – Academic Bodies & University Committees"
    ],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/telugu/NARASIMHULU.pdf"
  }
  ,
  {
    id: "tel002",
    name: "Dr. P. Sreenivasulu",
    role: "Assistant Professor (C)",
    department: "Telugu",
    university: "Rayalaseema University, Kurnool",

    photo: "/telugu/sreenivasulu.JPG",
    email: "srinivasulupurohitam3706@gmail.com",
    phone: "9440035438",

    dateOfBirth: "12-06-1965",
    dateOfJoining: "06-06-1998",

    qualification: "M.A. (Telugu), Ph.D.",

    about:
      "Dr. P. Sreenivasulu has over 28 years of teaching and research experience in Telugu language and literature. His specialization includes Folk and Old Literature along with Sanskrit. He has published extensively and received several awards for excellence in teaching and literary criticism.",

    education: [
      "B.A. – Sri Venkateswara University (1985)",
      "M.A. Telugu – Sri Venkateswara University (1988)",
      "Ph.D. – Sri Venkateswara University (1993)"
    ],

    specialization: [
      "Folk Literature",
      "Old Literature",
      "Sanskrit"
    ],

    experience: {
      teaching: "28 Years",
      research: "28 Years"
    },

    publications: {
      journalsNational: 40,
      journalsInternational: 40,
      conferences: 80,
      booksChapters: 10,
      total: 170
    },

    awards: [
      "Best Teacher Award – Lions Club (2006)",
      "Best Critic Award (2010)",
      "Best Pandit Award – International (2010)"
    ],

    memberships: [
      "Post Doctoral Fellowship (PDF)"
    ],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/telugu/SREENIVASULU.pdf"
  }
  ,
  {
    id: "tel003",
    name: "Dr. V. Ravi Sankar",
    role: "Assistant Professor (C)",
    department: "Telugu",
    university: "Rayalaseema University, Kurnool",

    photo: "/telugu/ravishankart.JPG",
    email: "dr.v.ravisankar@gmail.com",
    phone: "9440225207",

    dateOfBirth: "10-06-1978",
    dateOfJoining: "16-07-2000",

    qualification: "M.A. (Telugu), Ph.D.",

    about:
      "Dr. V. Ravi Sankar is an experienced faculty member with over 24 years of teaching experience. His academic interests include Classical Literature, Grammar, and Journalism. He has presented papers at national and international seminars and published research works in reputed journals.",

    education: [
      "B.A. – Sri Krishnadevaraya University (1998)",
      "M.A. Telugu – Sri Krishnadevaraya University (2000)",
      "Ph.D. – Sri Krishnadevaraya University (2005)"
    ],

    specialization: [
      "Classical Literature",
      "Grammar",
      "Journalism"
    ],

    experience: {
      teaching: "24 Years",
      research: "24 Years"
    },

    publications: {
      journalsNational: 13,
      journalsInternational: 0,
      conferences: 9,
      booksChapters: 1,
      total: 23
    },

    awards: [
      "Telugu Bhasha Dinotsavam Puraskaram – Ministry of Cultural Affairs, Govt. of Andhra Pradesh (29 Aug 2010)",
      "Telugu Kalasamiti Puraskaram – District Collector, Kurnool (21 Feb 2016)",
      "Krishna Pushkara Puraskaram – Dept. of Language & Culture, Govt. of Andhra Pradesh and Telugu Rakshana Vedika (Aug 2016)"
    ],

    memberships: [
      "Member – World Telugu Writers Association"
    ],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/telugu/RAVI.pdf"
  },
  {
    id: "tel004",
    name: "Dr. Anjaneyulu",
    role: "Assistant Professor (C)",
    department: "Telugu",
    university: "Rayalaseema University, Kurnool",

    photo: "/telugu/anjaneyulut.JPG",
    email: "premsantosh2014@gmail.com",
    phone: "9494736351",
    dateOfBirth: "01-06-1976",
    dateOfJoining: "15-03-2005",

    qualification: "M.A. (Telugu), Ph.D.",

    specialization: [
      "Modern Telugu Literature"
    ],
    awards: [
      "CP Brown Academy Essay Writing – First Prize (Jan 2012)",
      "JABALI Puraskar (2017)"
    ],

    memberships: [],


    experience: {
      teaching: "20+ Years"
    },
    publications: {
      journalsNational: 46,
      journalsInternational: 0,
      conferences: 5,
      booksChapters: 2,
      total: 53
    },

    profilePdf: "/telugu/anjaneyalusir.pdf"
  }
  ,
  {
    id: "tel005",
    name: "Dr. Aruna Gandam",
    role: "Assistant Professor (C)",
    department: "Telugu",
    university: "Rayalaseema University, Kurnool",

    photo: "/telugu/Aruna_Telugu.JPG",
    email: "arunagandham728@gmail.com",
    phone: "9701786222",
    dateOfBirth: "01-06-1980",
    dateOfJoining: "28-06-2017",

    qualification: "M.A. (Telugu), M.Phil., Ph.D.",

    specialization: [
      "Modern Poetry"
    ],

    experience: {
      teaching: "8+ Years"
    },
    awards: [
      "Conducted Two International Seminars",
      "Served as NSS Programme Officer & Coordinator",
      "Served as Deputy Warden"
    ],

    memberships: [],
    publications: {
      journalsNational: 5,
      journalsInternational: 2,
      conferences: 7,
      booksChapters: 5,
      total: 19
    },


    profilePdf: "/telugu/ARUNA-GANDAM.pdf"
  }
  ,
  {
    id: "tel006",
    name: "Dr. Medikurthi Obulesu",
    role: "Assistant Professor (C)",
    department: "Telugu",
    university: "Rayalaseema University, Kurnool",

    photo: "/telugu/obulesu.png",
    email: "medikurthiobulesu@gmail.com",
    phone: "8142177887",
    dateOfBirth: "08-06-1986",
    dateOfJoining: "28-06-2017",

    qualification: "M.A. (Telugu), M.Phil., Ph.D.",

    specialization: [
      "Modern Literature"
    ],

    experience: {
      teaching: "7+ Years"
    },
    publications: {
      journalsNational: 15,
      journalsInternational: 0,
      conferences: 0,
      booksChapters: 1,
      total: 16
    },

    profilePdf: "/telugu/MEDIKURTHI.pdf"
  }
  ,
  /* =====================================================
       Dr. Y. Raghunatha Reddy
    ===================================================== */
  {
    id: "stat001",
    name: "Dr. Y. Raghunatha Reddy",
    role: "Coordinator & Assistant Professor (C)",
    department: "Statistics (OR & SQC)",
    university: "Rayalaseema University, Kurnool",

    photo: "/statistics/Ragu.JPG",
    email: "drraghuy@gmail.com",
    phone: "8985858282",

    dateOfBirth: "01-06-1975",
    dateOfJoining: "01-08-1998",

    qualification: "B.A., M.Sc., Ph.D.",

    about:
      "Dr. Y. Raghunatha Reddy is a senior academician with 26 years of teaching and research experience in Statistics, Reliability Theory, and Statistical Quality Control. He has guided Ph.D. scholars, served as Assistant Director in the Directorate of Research Studies, and held key responsibilities in examinations, admissions, and NSS activities at Rayalaseema University.",

    specialization: [
      "Statistical Quality Control (SQC)",
      "Reliability Theory",
      "Optimization Techniques",
      "Operations Research"
    ],

    experience: {
      teaching: "26 Years",
      research: "26 Years"
    },

    publications: {
      journalsInternational: 38,
      journalsNational: 3,
      conferences: 4,
      booksChapters: 2,
      total: 47
    },

    awards: [
      "University First Rank in Post Graduate (M.Sc.) Degree Examinations",
      "Serving as Assistant Director, Directorate of Research Studies – Rayalaseema University, Kurnool",
      "Served as University College Officer for Higher Education Survey – Ministry of Human Resource Development",
      "Served as Coordinator, PG Examinations Valuation – Rayalaseema University, Kurnool",
      "Served as University NSS Programme Officer (2011–2013)"
    ],

    memberships: [
      "Life Member – Society of Quality, Reliability and IT, New Delhi",
      "Reviewer Panel Member – Academic Science (ISSN: 2347-8616, 2347-8527)",
      "Editorial Board Member – Institute for Exploring Advances in Engineering International Journals",
      "Editorial Board Member – International Journal of Latest Technology in Engineering, Management & Applied Science (IJLTEMAS)",
      "Review Member – Journal of Emerging Technology and Innovative Research (ISSN: 2349-5162)"
    ],


    profiles: {
      orcid: "0009-0001-5496-0424",
      scholar: "https://scholar.google.com/citations?user=YJ4fGaUAAAAJ",
      vidwan: "454507"
    },

    profilePdf: "/statistics/yrr.pdf"
  },

  /* =====================================================
     Dr. Bandaru Sainath
  ===================================================== */
  {
    id: "stat002",
    name: "Dr. Bandaru Sainath",
    role: "Assistant Professor (C)",
    department: "Statistics (OR & SQC)",
    university: "Rayalaseema University, Kurnool",

    photo: "/statistics/Sainanth.png",
    email: "bsainathphd@gmail.com",
    phone: "9908112071",

    dateOfBirth: "05-05-1987",
    dateOfJoining: "29-06-2017",

    qualification: "B.Sc. (M.P.S), M.Sc. Statistics, Ph.D.",

    about:
      "Dr. Bandaru Sainath is an Assistant Professor of Statistics specializing in Statistical Quality Control and Acceptance Sampling Plans. He has published extensively in international journals and actively participates in academic research, conferences, and university administrative activities.",

    specialization: [
      "Statistical Quality Control",
      "Acceptance Sampling Plans",
      "Reliability Analysis",
      "CUSUM Schemes"
    ],

    experience: {
      teaching: "7 Years 8 Months",
      research: "7+ Years"
    },

    publications: {
      journalsInternational: 6,
      journalsNational: 2,
      conferences: 3,
      booksChapters: 0,
      total: 11
    },

    awards: [
      "Worked as Deputy Warden for Students Hostel (Men) – Rayalaseema University College (29-01-2020 to 03-12-2020)",
      "Member – NAAC Committee",
      "Observer – RU DDE UG Examinations (June 2019)",
      "Observer – RU DDE UG Examinations (July/August 2021)"
    ],

    memberships: [
      "UGC Non-SAP Fellowship in Basic Science Research (BSR-RFSMS) – JRF & SRF (2011–2016)"
    ],

    profiles: {
      orcid: "0009-0003-9451-0967",
      scholar: "",
      vidwan: "454318"
    },

    profilePdf: "/statistics/sainath.pdf"
  },
  /* =====================================================
   Prof. N. T. K. Naik
===================================================== */
  {
    id: "eco001",
    name: "Prof. N. T. K. Naik",
    role: "Professor & Head",
    department: "Economics",
    university: "Rayalaseema University, Kurnool",

    photo: "/economics/naik.JPG",
    email: "drntknaik@gmail.com",
    phone: "9440861023",

    dateOfBirth: "01-09-1963",
    dateOfJoining: "November 1989",

    qualification: "M.A. Economics, Ph.D.",

    about:
      "Prof. N. T. K. Naik is a senior academician with over 35 years of teaching, research, and administrative experience. He has served Rayalaseema University in several key leadership roles including Rector, Registrar, Principal, Dean (Examinations), Director (DDE), and Controller of Examinations. His research contributions focus on agricultural economics, rural development, women empowerment, and Indian economic policy. He has guided multiple Ph.D. scholars and published extensively in national and international journals.",

    specialization: [
      "Agricultural Economics",
      "Indian Economic Policy",
      "Rural Development",
      "Women Empowerment",
      "Regional Economics"
    ],

    experience: {
      teaching: "35 Years",
      research: "35 Years"
    },

    publications: {
      journalsInternational: 7,
      journalsNational: 24,
      booksChapters: 3,
      conferences: 52,
      total: 86
    },

    awards: [
      "State Government Meritorious Teacher Award – Andhra Pradesh (2013)",
      "Bharat Ratna Mother Teresa Gold Medal Award (2017)",
      "Commendation Award – District Collector, Kurnool (2010, 2011)"
    ],

    memberships: [
      "Member – Indian Economics Association",
      "Member – Andhra Pradesh Economics Association",
      "Executive Body Member – SRK PG College, Nandyal",
      "Executive Body Member – Osmania College, Kurnool"
    ],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/economics/NTK-NAIK.pdf"
  },

  /* =====================================================
     Dr. N. Sreedhar
  ===================================================== */
  {
    id: "eco002",
    name: "Dr. N. Sreedhar",
    role: "Coordinator & Assistant Professor (C)",
    department: "Economics",
    university: "Rayalaseema University, Kurnool",

    photo: "/economics/nsreedhar.JPG",
    email: "sree7473@gmail.com",
    phone: "8897977473",

    dateOfBirth: "01-08-1971",
    dateOfJoining: "August 2001",

    qualification: "B.A., M.A., Ph.D.",

    about:
      "Dr. N. Sreedhar is an experienced academician with more than 23 years of teaching and research experience in Developmental Economics. His research interests include rural development, women empowerment, agricultural economics, and poverty studies. He has published research articles in reputed international journals, contributed book chapters, and guided Ph.D. scholars.",

    specialization: [
      "Developmental Economics",
      "Rural Development",
      "Women Empowerment",
      "Agricultural Economics"
    ],

    experience: {
      teaching: "23 Years",
      research: "23 Years"
    },

    publications: {
      journalsInternational: 5,
      journalsNational: 7,
      conferences: 3,
      booksChapters: 1,
      total: 16
    },

    awards: [
      "Received 4 awards from different academic institutions",
      "Attended four training programmes in different National Research Institutions",
      "Editorial Board Member – International Research Journal of India (2016)",
      "Editorial Board Member – Edwin Group of Journals of India (5 Feb 2025)"
    ],

    memberships: [],

    profiles: {
      scholar: "https://scholar.google.com/citations?user=xR0R90AAAAAJ",
      orcid: "",
      vidwan: "611052"
    },

    profilePdf: "/economics/sreedhar.pdf"
  },
  /* =====================================================
    A. Sreekanth
 ===================================================== */
  {
    id: "mech001",
    name: "A. Sreekanth",
    role: "Coordinator & Assistant Professor (Ad hoc)",
    department: "Mechanical Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/mechanics/sreekanth.JPG",
    email: "sreekanth.mec@ruce.ac.in",
    phone: "9652032966",

    dateOfBirth: "13-07-1988",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech, Ph.D. (Pursuing)",

    about:
      "Mr. A. Sreekanth is an Assistant Professor in the Department of Mechanical Engineering with over 11 years of teaching experience. His academic expertise lies in Advanced Manufacturing Systems. He has published research papers in national and international journals and actively participates in workshops and academic programs.",

    specialization: [
      "Advanced Manufacturing Systems"
    ],

    experience: {
      teaching: "11 Years 6 Months",
      research: "11+ Years"
    },

    publications: {
      journalsInternational: 2,
      journalsNational: 1,
      conferences: 4,
      booksChapters: 2,
      total: 9
    },

    awards: [
      "Ratified as Assistant Professor in JNTUA – Mechanical Engineering (2015)"
    ],

    memberships: [],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/mechanics/sreekanth.pdf"
  },

  /* =====================================================
     T. Gayatri
  ===================================================== */
  {
    id: "mech002",
    name: "T. Gayatri",
    role: "Assistant Professor (Ad hoc)",
    department: "Mechanical Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/mechanics/Gayatri.JPG",
    email: "gayatrigopal.mec@ruce.ac.in",
    phone: "9902145149",

    dateOfBirth: "16-07-1984",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech, Ph.D. (Pursuing)",

    about:
      "Ms. T. Gayatri is an Assistant Professor in Mechanical Engineering with more than 18 years of combined teaching and industry experience. Her specialization is Thermal Engineering. She has contributed to national-level publications and actively participates in academic workshops and seminars.",

    specialization: [
      "Thermal Engineering"
    ],

    experience: {
      teaching: "13 Years 3 Months",
      industry: "4 Years 10 Months",
      total: "18 Years 1 Month"
    },

     publications: {
      journalsInternational: 0,
      journalsNational: 1,
      conferences: 2,
      booksChapters: 0,
      total: 3
    },

    awards: [],

    memberships: [],

    profiles: {
      scholar: "",
      orcid: "0009-0005-6831-6639",
      vidwan: "679270"
    },

    profilePdf: "/mechanics/Gayatri.pdf"
  },

  /* =====================================================
     Bandaru Venkata Siva Prasad Reddy
  ===================================================== */
  {
    id: "mech003",
    name: "Bandaru Venkata Siva Prasad Reddy",
    role: "Assistant Professor (Ad hoc)",
    department: "Mechanical Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/mechanics/shivaprasad.JPG",
    email: "sivaprasad.mec@ruce.ac.in",
    phone: "7382440309",

    dateOfBirth: "01-06-1990",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech, Ph.D. (Pursuing)",

    about:
      "Mr. Bandaru Venkata Siva Prasad Reddy is an Assistant Professor in Mechanical Engineering specializing in Production Engineering, Functionally Graded Composite Materials, and 3D Printing. He has published international research papers and is actively involved in teaching, research, NSS activities, and examination administration.",

    specialization: [
      "Production Engineering",
      "Functionally Graded Composite Materials",
      "3D Printing",
      "Additive Manufacturing"
    ],

    experience: {
      teaching: "10 Years 2 Months",
      research: "10+ Years"
    },

    publications: {
      journalsInternational: 3,
      journalsNational: 0,
      conferences: 3,
      booksChapters: 0,
      total: 6
    },

    awards: [
  "GATE Qualified (2012)",
  "Placement Coordinator – Mechanical Engineering Department (July 2016 – July 2021)",
  "Awarded in Build Your 3D Contest in Rapid Casting Techniques – IMIK Technologies (Dec 2017)",
  "Donated blood 12 times at different locations",
  "NSS Programme Officer (Unit V) – Rayalaseema University (from 19-01-2023 to till date)",
  "Exam Section In-charge – Rayalaseema University College of Engineering (2021–2022 to 2024–2025)"
],

memberships: [
  "Lifetime Member – International Society for Research and Development",
  "Member – Institute of Research Engineers and Doctors"
],


    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/mechanics/shivaprasad.pdf"
  },
  /* =====================================================
    Sri. G. Vinod Kumar
 ===================================================== */
  {
    id: "civil001",
    name: "Sri. G. Vinod Kumar",
    role: "Coordinator & Assistant Professor (Ad hoc)",
    department: "Civil Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/civil/vinodh.JPG",
    email: "vinod.civ@ruce.ac.in",
    phone: "9989981013",

    dateOfBirth: "15-06-1992",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech, Ph.D. (Pursuing)",

    about:
      "Sri. G. Vinod Kumar is an Assistant Professor in Civil Engineering with specialization in Developmental Economics applied to civil infrastructure and construction systems. He has qualified GATE multiple times and has published research papers in international journals and conferences. He actively participates in academic seminars and workshops.",

    specialization: [
      "Developmental Economics",
      "Construction Materials",
      "Concrete Technology"
    ],

    experience: {
      teaching: "4 Years",
      research: "4 Years"
    },

    publications: {
      journalsInternational: 1,
      journalsNational: 0,
      conferences: 0,
      booksChapters: 0,
      total: 1
    },

    awards: [
      "Qualified GATE – 2013, 2016, 2017, 2018, 2019, 2021",
      "Best Score in GATE 2021 – 60/100"
    ],

    memberships: [],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/civil/vinodh.pdf"
  },

  /* =====================================================
     Smt. Y. Deepthi
  ===================================================== */
  {
    id: "civil002",
    name: "Smt. Y. Deepthi",
    role: "Assistant Professor (Ad hoc)",
    department: "Civil Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/civil/deepthi.jpeg",
    email: "deepthi.civ@ruce.ac.in",
    phone: "8897952866",

    dateOfBirth: "30-11-1996",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech",

    about:
      "Smt. Y. Deepthi is an Assistant Professor in Civil Engineering with research interests in Developmental Economics and sustainable construction practices. She has published research articles in national and international journals and actively participates in seminars, conferences, and workshops.",

    specialization: [
      "Developmental Economics",
      "Geopolymer Concrete",
      "Sustainable Construction Materials"
    ],

    experience: {
      teaching: "4 Years",
      research: "4 Years"
    },

    publications: {
      journalsInternational: 1,
      journalsNational: 1,
      conferences: 0,
      booksChapters: 0,
      total: 2
    },

    awards: [
      "Qualified GATE – 2017"
    ],

    memberships: [],

    profiles: {
      scholar: "https://scholar.google.com/citations?view_op=new_articles&hl=en&imq=DEEPTHI+Y#",
      orcid: "0000-0003-3283-3333",
      vidwan: "679262"
    },

    profilePdf: "/civil/deepthi.pdf"
  },

  /* =====================================================
     Shaik Gulnar
  ===================================================== */
  {
    id: "civil003",
    name: "Shaik Gulnar",
    role: "Assistant Professor (Ad hoc)",
    department: "Civil Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/civil/ShaikGulnar.JPG",
    email: "gulnar.civ@ruce.ac.in",
    phone: "8519885415",

    dateOfBirth: "28-10-1995",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech, Ph.D. (Pursuing)",

    about:
      "Shaik Gulnar is an Assistant Professor in Civil Engineering specializing in Structural Engineering. Her research focuses on self-compacting concrete and micro-structural properties of construction materials. She has published conference papers and actively participates in international conferences.",

    specialization: [
      "Structural Engineering",
      "Concrete Technology",
      "Self Compacting Concrete"
    ],

    experience: {
      teaching: "4 Years",
      research: "4 Years"
    },

    publications: {
      journalsInternational: 1,
      journalsNational: 0,
      conferences: 1,
      booksChapters: 0,
      total: 2
    },

    awards: [],

    memberships: [],

    profiles: {
      scholar: "",
      orcid: " 0009-0002-2029-0220",
      vidwan: "679272"
    },

    profilePdf: "/civil/ShaikGulnar.pdf"
  },
  /* =====================================================
    B. A. Sarath Manohar Babu
 ===================================================== */
  {
    id: "ece001",
    name: "B. A. Sarath Manohar Babu",
    role: "Coordinator & Assistant Professor (Ad hoc)",
    department: "Electronics and Communication Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/ece/sarath.JPG",
    email: "Hod.ece@ruce.ac.in",
    phone: "7013644322",

    dateOfBirth: "26-08-1976",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech (ECE), M.Tech (DECS)",

    about:
      "Mr. B. A. Sarath Manohar Babu is a senior academician with 25 years of combined teaching and industry experience in Electronics and Communication Engineering. His expertise lies in Embedded Systems and IoT. He has guided more than 100 B.Tech and 20 M.Tech projects, published several international journal papers, and played a key role in NBA accreditation activities as department coordinator.",

    specialization: [
      "Embedded Systems",
      "Internet of Things (IoT)",
      "Wireless Communication",
      "Signal Processing"
    ],

    experience: {
      teaching: "23 Years",
      industry: "2 Years",
      total: "23 Years"
    },

    publications: {
      journalsInternational: 0,
      journalsNational: 0,
      conferences: 7,
      booksChapters: 0,
      total: 7
    },

    awards: [
  "Best Faculty Award – ECE Department (2018–2019)",
  "Best Faculty Award – ECE Department (2010–2011)",
  "Best Coordinator Award for NBA Accreditation – ECE Department",
  "Department NBA Coordinator – ECE Department",
  "Convener and Sports In-charge for entire college",
  "Faculty Advisor – IETE Students Forum, ECE Department",
  "Conducted more than 25 workshops for students",
  "Guided more than 100 B.Tech projects and more than 20 M.Tech projects",
  "15 days workshop on Teaching Methodologies – St. Peter’s Engineering College, Hyderabad",
  "2-day Workshop on Robotics – St. Peter’s Engineering College, Hyderabad",
  "2-day Workshop on Embedded Systems & Applications – ASCET, Gudur (9–10 Dec 2010)",
  "3-day Workshop on Cadence Design Tools & Applications – ASCET, Gudur (4–6 Nov 2010)",
  "Workshop on ARM9 – ISM, Bangalore (Oct 2009)",
  "Workshop on PSOC & ARM Processors – G. Pulla Reddy Engineering College, Kurnool"
],

memberships: [
  "Associate Member – The Institution of Engineers (IEI)",
  "Member – Institution of Electronics and Telecommunication Engineers (IETE)"
],


    profiles: {
      scholar: "",
      orcid: "0000-0005-5652-9186",
      vidwan: "679248"
    },

    profilePdf: "/ece/sarath.pdf"
  },

  /* =====================================================
     Mohammed Abdul Farida
  ===================================================== */
  {
    id: "ece002",
    name: "Mohammed Abdul Farida",
    role: "Assistant Professor (Ad hoc)",
    department: "Electronics and Communication Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/ece/farida.JPG",
    email: "mafarida01.ece@ruce.ac.in",
    phone: "9885448606",

      dateOfBirth: "10-04-1985",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech, Ph.D.",

    about:
      "Dr. Mohammed Abdul Farida is an Assistant Professor in ECE specializing in VLSI and Semiconductor Devices. She actively contributes to teaching and research in advanced VLSI design and has published research work in reputed journals.",

    specialization: [
      "VLSI Design",
      "Semiconductor Devices",
      "Digital Electronics"
    ],

    experience: {
      teaching: "16+ Years",
      research: "8+ Years"
    },

    publications: {
      journalsInternational: 4,
      journalsNational: 1,
      conferences: 8,
      booksChapters: 1,
      total: 14
    },

   awards: [
  "SWAYAM Online Course on Research Methodology and IPR – 90% (May 2025)",
  "NPTEL Online Certification on Semiconductor Devices for Next Generation FETs – 71% (Jan–Apr 2025)",
  "NPTEL Online Certification on VLSI Physical Design – 62% (Jan–Apr 2025)",
  "NPTEL Online Certification on Teaching and Learning in General Programs (TALG) – Elite (Jul–Aug 2021)",
  "NPTEL Online Certification on Fundamentals of Electronic Device Fabrication – Elite (Jul–Aug 2019)",
  "NPTEL Online Certification on Effective Engineering Teaching in Practice – Elite+Silver (Jan–Feb 2019)",

  "ATAL Academy FDP on Next Wave: Advancements in Next Generation Communications (25–30 Aug 2025)",
  "One-week National FDP on Advanced Analog and Digital IC Design using Cadence EDA Tools (3–7 Dec 2024)",
  "Capacity Development Programme – GPREC, Kurnool (23–25 Feb 2024)",
  "Certificate of Appreciation – Speaker, ExcelR-APSCHE Internship Program (2024)",
  "Certificate of Appreciation – Bridging Education and Industry, Kodnest (2023)",
  "Certificate of Excellence – AIR 214, Internshala Annual Rankings (2023)",
  "Certificate of Appreciation – Judge, Community Outreach Programme (2023)",
  "Six-day Master Training Program for Community Service Project (Oct–Nov 2022)"
],

memberships: [
  "Member – Institute for Engineering Research and Publications (PMIN01947586)"
],


    profiles: {
      scholar: "",
      orcid: "0000-0002-9524-3245",
      vidwan: "679243"
    },

    profilePdf: "/ece/farida.pdf"
  },

  /* =====================================================
     Dr. K. Vanitha
  ===================================================== */
  {
    id: "ece003",
    name: "Dr. K. Vanitha",
    role: "Assistant Professor (Ad hoc)",
    department: "Electronics and Communication Engineering",
    university: "Rayalaseema University College of Engineering",

    photo: "/ece/vineetha.JPG",
    email: "vanitha09.ece@ruce.ac.in",
    phone: "6304313644",

    dateOfBirth: "07-06-1989",
    dateOfJoining: "July 2021",

    qualification: "B.Tech, M.Tech, Ph.D.",

    about:
      "Dr. K. Vanitha is an accomplished researcher and academician specializing in Biomedical Image Processing. She has published several high-impact international journal papers indexed in SCIE and Scopus, guided research projects, and holds a published patent. Her research focuses on multimodal medical image fusion using advanced deep learning and fuzzy systems.",

    specialization: [
      "Biomedical Image Processing",
      "Medical Image Fusion",
      "Deep Learning",
      "Signal Processing"
    ],

    experience: {
      teaching: "15 Years",
      research: "15 Years"
    },

    publications: {
      journalsInternational: 7,
      journalsNational: 0,
      conferences: 11,
      booksChapters: 0,
      total: 18
    },

    awards: [
  "GATE Qualified (2012)",
  "UGC NET Qualified as Assistant Professor (June 2015)",
  "Ratified as Assistant Professor – JNTUA (2015)",
  "One Patent Published (August 2025)"
],

memberships: [
  "Member – ISTE (Indian Society for Technical Education)"
],


    profiles: {
      scholar: "https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=vanithakamarthi%40gmail.com&btnG=",
      orcid: "ORCID- 0000-0002-8942-3581",
      vidwan: "679266"
    },

    profilePdf: "/ece/vineetha.pdf"
  },
  /* =====================================================
     V. Satish Kumar
  ===================================================== */
  {
    id: "ai001",
    name: "V. Satish Kumar",
    role: "Coordinator & Assistant Professor (Ad hoc)",
    department: "Artificial Intelligence ,CSE",
    university: "Rayalaseema University College of Engineering",

    photo: "/artificialintelligence/sathis.JPG",
    email: "valmikisatish71@gmail.com",
    phone: "9866248428",

    dateOfBirth: "08-06-1985",
    dateOfJoining: "05-07-2021",

    qualification: "B.Tech, M.Tech, Ph.D. (Pursuing)",

    about:
      "Mr. V. Satish Kumar is an Assistant Professor with more than 12 years of combined teaching and industry experience. His academic and research interests include Computer Networks, Artificial Intelligence, and Machine Learning. He has published research papers in Scopus-indexed journals, presented papers at national and international conferences, and holds a published Indian patent in cloud computing resource optimization.",

    specialization: [
      "Computer Networks",
      "Artificial Intelligence",
      "Machine Learning",
      "Cloud Computing"
    ],

    experience: {
      teaching: "10 Years",
      industry: "2 Years",
      total: "12 Years"
    },

    publications: {
      journalsInternational: 4,
      journalsNational: 4,
      conferences: 5,
      booksChapters: 0,
      total: 13
    },

    awards: [
  "Ratified as Assistant Professor in CSE – JNTUA, Anantapuram (21 April 2016)",
  "Guided several B.Tech and M.Tech student projects"
],

memberships: [],

    profiles: {
      scholar: "",
      orcid: "",
      vidwan: ""
    },

    profilePdf: "/artificialintelligence/sathis.pdf"
  },
  /* =====================================================
     Dr. S. Naga Chandrudu
  ===================================================== */
  {
    id: "hs001",
    name: "Dr. S. Naga Chandrudu",
    role: "Coordinator & Assistant Professor (Ad hoc)",
    department: "Humanities & Basic Sciences",
    university: "Rayalaseema University College of Engineering",

    photo: "/hs/nagachandrudu.JPG",
    email: "chandu.rucek@gmail.com",
    phone: "8247288315",

    dateOfBirth: "04-06-1988",
    dateOfJoining: "28-08-2019",

    qualification: "B.Sc., M.Sc., Ph.D.",

    about:
      "Dr. S. Naga Chandrudu is an Assistant Professor in Humanities & Basic Sciences with specialization in Developmental Economics. He has nine years of teaching and research experience and has previously served as a CSIR Junior Research Fellow and Senior Research Fellow. His research work focuses on sustainable development and socio-economic studies, with multiple publications in reputed international journals.",

    education: [
      "B.Sc. – Sri Krishna Devaraya University (2009)",
      "M.Sc. – Sri Venkateswara University (2011)",
      "Ph.D. – University of Delhi (2016)"
    ],

    specialization: [
      "Developmental Economics"
    ],

    experience: {
      teaching: "9 Years",
      research: "9 Years"
    },

    publications: {
      journalsInternational: 7,
      journalsNational: 0,
      conferences: 4,
      booksChapters: 0,
      total: 11
    },

    awards: [
      "Qualified CSIR All India Entrance Examination – 51st Rank"
    ],

    memberships: [
      "CSIR Junior Research Fellow (Dec 2011 – Mar 2013)",
      "CSIR Senior Research Fellow (Apr 2013 – Jul 2015)"
    ],

    profiles: {
      orcid: "0000-0001-8116-4290",
      scholar: "",
      vidwan: ""
    },

    profilePdf: "/hs/nagachandrudu.pdf"
  },





]

export default facultyProfiles
